/**
 * Staff Portal Services Module
 * SDK services for staff portal operations.
 *
 * These services allow staff (employees) to manage their own HR data
 * through dedicated portal endpoints with role-based access control.
 *
 * Security:
 * - All requests require JWT authentication with "Staff" role
 * - Staff can only access their own data
 * - HROnly files are restricted from staff access
 * - Server validates user ownership for all operations
 */
// Base service
export { StaffPortalBaseService } from './StaffPortalBaseService';
// Leave operations
export { StaffPortalLeaveService } from './StaffPortalLeaveService';
// Leave document management
export { StaffPortalLeaveDocumentService } from './StaffPortalLeaveDocumentService';
// Profile management
export { StaffPortalProfileService } from './StaffPortalProfileService';
// File management
export { StaffPortalFileService } from './StaffPortalFileService';
// Policy assignments (signing flow)
export { StaffPortalPolicyAssignmentService } from './StaffPortalPolicyAssignmentService';
// HR announcements (read-only, published only)
export { StaffPortalAnnouncementService } from './StaffPortalAnnouncementService';
// Calendar feeds (birthdays, on-leave)
export { StaffPortalCalendarService } from './StaffPortalCalendarService';
// Lookups (leave types, statuses, colleagues, etc.)
export { StaffPortalLookupsService } from './StaffPortalLookupsService';
// Duty catalogue + my duties
export { StaffPortalDutyService } from './StaffPortalDutyService';
// Leave-duty associations
export { StaffPortalLeaveDutyService } from './StaffPortalLeaveDutyService';
// Policy library (read-only browse of policies)
export { StaffPortalPolicyService } from './StaffPortalPolicyService';
// Models
export * from './models';
// Import for factory function
import { StaffPortalLeaveService } from './StaffPortalLeaveService';
import { StaffPortalLeaveDocumentService } from './StaffPortalLeaveDocumentService';
import { StaffPortalProfileService } from './StaffPortalProfileService';
import { StaffPortalFileService } from './StaffPortalFileService';
import { StaffPortalPolicyAssignmentService } from './StaffPortalPolicyAssignmentService';
import { StaffPortalAnnouncementService } from './StaffPortalAnnouncementService';
import { StaffPortalCalendarService } from './StaffPortalCalendarService';
import { StaffPortalLookupsService } from './StaffPortalLookupsService';
import { StaffPortalDutyService } from './StaffPortalDutyService';
import { StaffPortalLeaveDutyService } from './StaffPortalLeaveDutyService';
import { StaffPortalPolicyService } from './StaffPortalPolicyService';
/**
 * Create all staff portal services
 * @param http - HttpClient instance
 * @param config - Optional service configuration
 * @returns Object containing all staff portal services
 */
export function createStaffPortalServices(http, config) {
    const leaves = new StaffPortalLeaveService(http, config);
    const leaveDocuments = new StaffPortalLeaveDocumentService(http, config);
    const profile = new StaffPortalProfileService(http, config);
    const files = new StaffPortalFileService(http, config);
    const policyAssignments = new StaffPortalPolicyAssignmentService(http, config);
    const announcements = new StaffPortalAnnouncementService(http, config);
    const calendar = new StaffPortalCalendarService(http, config);
    const lookups = new StaffPortalLookupsService(http, config);
    const duties = new StaffPortalDutyService(http, config);
    const leaveDuties = new StaffPortalLeaveDutyService(http, config);
    const policies = new StaffPortalPolicyService(http, config);
    return {
        leaves,
        leaveDocuments,
        profile,
        files,
        policyAssignments,
        announcements,
        calendar,
        lookups,
        duties,
        leaveDuties,
        policies,
    };
}
//# sourceMappingURL=index.js.map